const PAGES = {
  HOMEPAGE: "Homepage",
  DASHBOARD: "Dashboard",
  NOTIFICATION_MANAGER: "Notification Manager",
  PROFILE_PAGE: "Profile Page",
  WORKFLOW: "Workflow",
  EDIT_VENDOR_PROFILE: "Edit Vendor Profile",
  WELCOME_PAGE: "Welcome Page",
  END_USER_ONBOARDING: "EU Onboarding Page",
  MANAGE_VENDORS: "Manage Vendors",
  ALL_VENDORS: "All Vendors",
  ACTIVITY_TRACKING: "Activity Tracking",
  BULK_IMPORT_VENDORS: "Bulk Import Vendors",
  VIEW_IMPORTED_VENDORS: "View Imported Vendors",
  VENDOR_PREFERENCES: "Vendor Preferences",
  VENDOR_PROFILE_SETUP: "Vendor Profile Setup",
  VENDOR_WELCOME_PAGE: "Vendor Welcome Page",
  EU_SELF_IMPORT_QUESTIONNAIRE: "EU Self-Import Questionnaire",
  EU_VENDOR_ATTESTED_RESPONSES: "EU - Vendor Attested Responses",
  ERROR_PAGE: "Error Page",
  ACCESS_REMOVED_PAGE: "Access Removed Page",
  GUEST_USER_PAGE: "Guest User Page",
  EU_ASSESSED_VENDOR_CONTROLS: "Review Vendor Control Assessment",
};

const RoutesMappingConstants = {
  ROUTES_PAGE_MAPPING: {
    "/cybersecurity-insights": PAGES.HOMEPAGE,
    "/cybersecurity-insights/": PAGES.HOMEPAGE,
    "/cybersecurity-insights/dashboard": PAGES.DASHBOARD,
    "/cybersecurity-insights/settings": PAGES.NOTIFICATION_MANAGER,
    "/cybersecurity-insights/risk-profile": PAGES.PROFILE_PAGE,
    "/cybersecurity-insights/risk-profile/edit": PAGES.EDIT_VENDOR_PROFILE,
    "/cybersecurity-insights/lets-get-started": PAGES.WELCOME_PAGE,
    "/cybersecurity-insights/user-onboarding": PAGES.END_USER_ONBOARDING,
    "/cybersecurity-insights/manage-vendors": PAGES.MANAGE_VENDORS,
    "/cybersecurity-insights/all-vendors": PAGES.ALL_VENDORS,
    "/cybersecurity-insights/team-activity": PAGES.ACTIVITY_TRACKING,
    "/cybersecurity-insights/import-vendors": PAGES.BULK_IMPORT_VENDORS,
    "/cybersecurity-insights/import-vendors-validation":
      PAGES.VIEW_IMPORTED_VENDORS,
    "/cybersecurity-insights/preferences": PAGES.VENDOR_PREFERENCES,
    "/cybersecurity-insights/profile-setup": PAGES.VENDOR_PROFILE_SETUP,
    "/cybersecurity-insights/vendor-onboarding": PAGES.WELCOME_PAGE,
    "/cybersecurity-insights/risk-profile/edit-eu":
      PAGES.EU_SELF_IMPORT_QUESTIONNAIRE,
    "/cybersecurity-insights/risk-profile/vendor-ques":
      PAGES.EU_VENDOR_ATTESTED_RESPONSES,
    "/cybersecurity-insights/error": PAGES.ERROR_PAGE,
    "/cybersecurity-insights/access-denied": PAGES.ACCESS_REMOVED_PAGE,
    "/cybersecurity-insights/risk-profile/browse": PAGES.GUEST_USER_PAGE,
    "/cybersecurity-insights/risk-profile/eu-assessed-vendor-controls":
      PAGES.EU_ASSESSED_VENDOR_CONTROLS,
  },
  PAGES,
};

export { RoutesMappingConstants };
export default RoutesMappingConstants;
